import axiosAdapter from '../axiosAdapter'

const request = httpAdapter => {
    return {
        get: async (url, params, config = null) => {
            return await httpAdapter.get(url, params, config)
        },
        post: async (url, data, config = null) => {
            return await httpAdapter.post(url, data, config)
        },
        addResponseMiddleware: middleware => {
            return httpAdapter.addResponseMiddleware(middleware)
        },
    }
}

export default request(axiosAdapter())
